import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: "S'agit-il d'un produit physique ou d'un téléchargement numérique ?",
  a: "Il s'agit d'un produit 100 % numérique livré immédiatement au format PDF haute qualité. Vous pourrez y accéder instantanément depuis votre ordinateur, votre tablette ou votre smartphone dès la validation de votre commande."
}, {
  q: 'Ce système convient-il aux nouveaux professeurs de danse ?',
  a: "Absolument. Il a été conçu aussi bien pour les enseignants débutants qui souhaitent disposer d'une méthode claire que pour les professeurs expérimentés qui veulent gagner du temps, mieux organiser leurs cours et proposer un enseignement encore plus professionnel."
}, {
  q: "Puis-je l'utiliser avec des élèves de différents niveaux ?",
  a: "Oui. Le système a été pensé pour les professeurs travaillant avec des enfants, des adolescents ou des adultes, du niveau débutant jusqu'aux niveaux les plus avancés. Les contenus peuvent facilement être adaptés à votre groupe."
}, {
  q: 'Puis-je personnaliser les cours selon mon propre style ?',
  a: "Bien sûr. Chaque cours, chaque progression, chaque exercice et chaque ressource pédagogique peut être adapté à vos objectifs, à votre discipline, au niveau de vos élèves et à votre façon d'enseigner."
}, {
  q: 'À partir de quand vais-je constater les premiers résultats ?',
  a: "La plupart des professeurs constatent dès leurs premières utilisations qu'ils gagnent plusieurs heures de préparation chaque semaine. Ils se sentent également mieux organisés, plus sereins et beaucoup plus confiants lors de leurs cours."
}, {
  q: 'Est-ce adapté pour tous les styles de danse (Classique, Jazz, Contemporain, Hip-Hop...) ?',
  a: "Oui ! Les structures de cours, les méthodes de planification et les outils d'organisation sont universels. Les principes pédagogiques s'appliquent parfaitement à n'importe quel style de danse."
}, {
  q: 'Comment vais-je recevoir les 5 bonus premium ?',
  a: "Les 5 bonus sont inclus gratuitement avec votre achat d'aujourd'hui. Ils vous seront livrés instantanément par e-mail avec le système principal, prêts à être téléchargés et utilisés."
}, {
  q: 'Dois-je payer un abonnement mensuel ?',
  a: "Non, il s'agit d'un paiement unique de 27 eur. Vous obtenez un accès à vie à l'ensemble du système DANCE PRO™ et à tous ses bonus, sans aucun frais caché ni abonnement."
}, {
  q: 'Puis-je imprimer les fiches et les planificateurs ?',
  a: "Tout à fait. Tous les documents (fiches d'évaluation, planificateurs, feuilles de présence) sont conçus en haute résolution pour être facilement imprimés et utilisés au format papier dans votre studio."
}, {
  q: 'Comment fonctionne la garantie de 7 jours ?',
  a: "C'est très simple : vous avez 7 jours pour tester le système. Si vous n'êtes pas entièrement satisfait, envoyez-nous un simple e-mail et nous vous rembourserons 100 % de votre achat, sans poser de questions."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 px-4 sm:px-6 bg-white" data-id="element-34">
      <div className="text-center mb-6" data-id="element-35">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-title mb-2 uppercase leading-tight" data-id="element-36">
          QUESTIONS FRÉQUEMMENT POSÉES
        </h2>
      </div>

      <div className="flex flex-col gap-2" data-id="element-37">
        {faqs.map((faq, i) => <div key={i} className="bg-brand-ivory border border-brand-cream rounded-lg overflow-hidden shadow-sm" data-id="element-38">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3.5 text-left flex justify-between items-center hover:bg-brand-cream/50 transition-colors gap-3" data-id="element-39">
              <span className="font-bold text-brand-title text-sm sm:text-base leading-tight" data-id="element-40">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-brand-rose transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-41" />
            </button>

            {openIndex === i && <div className="px-4 pb-4 pt-0 text-brand-text font-medium text-sm sm:text-base leading-relaxed" data-id="element-42">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}